module.exports = "/static/assets/17b20e238552e00772bee085bda0b094.png";